/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Gradelevel_E22Inputs */

const en__field__enum_gradelevel_e22 = /** @type {(inputs: _Field__Enum_Gradelevel_E22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E2`)
};

const de__field__enum_gradelevel_e22 = /** @type {(inputs: _Field__Enum_Gradelevel_E22Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E2`)
};

/**
* | output |
* | --- |
* | "E2" |
*
* @param {_Field__Enum_Gradelevel_E22Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_gradelevel_e22 = /** @type {((inputs?: _Field__Enum_Gradelevel_E22Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Gradelevel_E22Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_gradelevel_e22(inputs)
	return de__field__enum_gradelevel_e22(inputs)
});
export { _field__enum_gradelevel_e22 as "_field__enum_gradeLevel_E2" }